<template>
    <div class="c_edit_meeting-link_container">
        <div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
        <a-card :bordered="false" class="card-apply header-solid h-full widget-1" :bodyStyle="{paddingTop: 0}">
            <template #title>
                <a-row type="flex" align="middle">
                    <a-col :span="48" :md="24" style="display:flex;justify-content:center;margin-bottom:30px">
                        <h5 class="font-semibold m-0">{{$t('meeting-link-create-page.sub-title')}}</h5>
                    </a-col>
                </a-row>
            </template>
            <a-form  :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
                    <!-- :label= "$t('form-label.name')" -->
                <a-form-item 
                    :validate-status="validations.statusName"
                    :help="validations.helpName"
                     style="display:flex;justify-content:center"
                >
                    <label 
                        class="ml-10" 
                        style="color: #000; font-weight:600"
                    >{{$t('form-label.name')}} <b style="color:red">(*)</b>
                    </label>
                    <a-input
                        class="form-input"
                        :placeholder= "$t('form-placeholder.name')"
                        v-model="name"
                    />
                </a-form-item>

                    <!-- :label= "$t('form-label.link')" -->
                <a-form-item 
                    :validate-status="validations.statusLink"
                    :help="validations.helpLink"
                    style="display:flex;justify-content:center"
                >
                    <label 
                        class="ml-10" 
                        style="color: #000; font-weight:600"
                    >{{$t('form-label.link')}} <b style="color:red">(*)</b>
                    </label>
                    <a-input
                        class="form-input"
                        :placeholder= "$t('form-placeholder.link')"
                        v-model="link"
                    />
                </a-form-item>

                    <!-- :label= "$t('form-label.official')" -->
                <a-form-item 
                    :validate-status="validations.selectedStatus"
                    :help="validations.helpStatus"
                    style="display:flex;justify-content:center"
                >
                    <label 
                        class="ml-10" 
                        style="color: #000; font-weight:600"
                    >{{$t('form-label.official')}} <b style="color:red">(*)</b>
                    </label>
                    <a-select
                        :disabled="isLoading"
                        :loading="isLoading"
                        :value="selectedOfficial"
                        :filter-option="false"
                        :not-found-content="isLoading ? undefined : null"
                        class="form-input"
                        show-search
                        :placeholder="$t('apply.step-2.appointment-official-placeholder')"
                        @search="filterOfficials"
                        @change="onChangeOfficialSelection">
                        <a-spin v-if="isLoading" slot="notFoundContent" size="large" />
                        <a-select-option v-for="item in officials" :key="item.id" :value="item.id">
                            <span role="img" style="margin-right: 20px;">
                                <a-avatar shape="square" :src="item.imageUrl" />
                            </span>
                            <!-- {{ item.name }} -->
                            <span>{{ item.name }} ({{$t('apply.step-1.rdcd')}})</span> 
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
                    <a-button type="primary" class="mr-10 ml-15 mt-40" html-type="submit">
                        {{$t('department-update-page.update-btn-caption')}}
                    </a-button>
                    <a-button type="danger"  @click="navigateTo('MeetingsLink')">
                        {{$t('department-create-page.cancel-btn-caption')}}
                    </a-button>
                </a-form-item>
            </a-form>  

            <!-- </template> -->
        </a-card>
    </div>
</template>

<script>
import { host, officialsClient, meetingsClient } from "../../api/config.js";
import { toastMixin } from "../../mixins/ToastMixin.js";
import { navigationMixin } from "../../mixins/navigation-mixin.js";
export default {
    name: "EditMeetingLink",
    mixins: [ toastMixin, navigationMixin ],
    data(){
        return {
            id: "",
            name: "",
            selectedOfficial: '',
            selectedOfficialId: '',
            officials: [],
            allOfficials: [],
            link: "",
            validations:{
                statusName: "",
                helpName: "",
                statusLink: "",
                helpLink: "",
            },
            isLoading: false
        }
    },
    methods:{
        onChangeOfficialSelection(e) {
            this.selectedOfficialId = e;
            this.selectedOfficial = e;
            this.selectedOfficialId = e;
            this.$emit('change', this.value);
        },
        filterOfficials(input) {
            this.officials = this.allOfficials.filter(o => o.name.toLowerCase().includes(input.toLowerCase()));
        },
        clearValidations() {
            Object.keys(this.validations).forEach(key => {
                this.validations[key] = '';
            });
        },
        validate() {
            this.clearValidations();
            if (this.name.trim().length == 0) {
                this.validations.statusName = 'error';
                this.validations.helpName = this.$t('error-message.name');
                return false;
            }
            if (this.link.trim().length == 0) {
                this.validations.statusLink = 'error';
                this.validations.helpLink = this.$t('error-message.link');
                return false;
            }
            return true;
        },
        handleSubmit(e){
            e.preventDefault();
            console.log(e);
            if (this.validate()){
                let submitData = {
                    id: this.id,
                    name: this.name,
                    link: this.link,
                    officialId: this.selectedOfficialId
                }
                // console.log(submitData);
                meetingsClient.update(submitData).then((res) => {
                    if (!res.networkError){
                        this.successToast(this.$t('toast-success-messages.create-meeting-link'));
                        this.navigateTo("MeetingsLink");
                    }
                })
            }
        },

    },
    mounted(){
        this.isLoading = true;
        officialsClient.fetchAllOfPage({ page: 1, size: 20, status: 'ACTIVE' }).then(res => {
            if (!res.networkError && res.body && res.body.list) {
                console.log(res.body.list);
                res.body.list.forEach(o => {
                    if (!o.imageUrl || o.imageUrl.trim().length == 0)
                        o.imageUrl = '/images/default-avatar.jpg';
                    else
                        o.imageUrl = host + o.imageUrl;
                });
                this.allOfficials = res.body.list;
                this.officials = res.body.list;
                // if (this.allOfficials.length > 0)
                //     this.selectedOfficial = this.allOfficials[0].id;
            } else {
                /* TODO: show error */
            }
            this.isLoading = false;
        });
    },

    watch:{
        '$route.query': {
            immediate: true,
            handler: function(newVal){
                let id = newVal.id;
                console.log(id);
                meetingsClient.fetchMeetingLinkById(id).then(res =>{
                    if(!res.networkError){
                        console.log(res.body);
                        this.id = res.body.id;
                        this.name = res.body.name;
                        this.link = res.body.link;
                        this.selectedOfficial = res.body.official.id;
                        this.selectedOfficialId = res.body.official.id;
                        // this.status = res.body.status;
                    }
                })

            }
        }
    }

}
</script>

<style>

</style>